import { colors as legacyColours } from '@offerzen/pinata-shame'

const colors = {
  ...legacyColours,
  darkEclipse: '#131F4A',
}

export default colors
